<!--
 * @Author: 范朝阳
 * @Date: 2020-12-21 17:04:45
 * @LastEditTime: 2020-12-21 17:27:23
 * @LastEditors: 范朝阳
 * @Description: 修改描述
 * @FilePath: /trunk/src/components/UmSelect/index.vue
-->
<template>
  <div
    class="um-control"
    :class="{'show':show}"
    :style="{
      paddingLeft:label?labelWidth+'px':0,
      paddingRight:childrenWidth>parentWidth?'60px':0
    }"
  >
    <span
      v-if="label"
      ref="child"
      class="label"
      :style="{
        width: labelWidth+'px',
        marginLeft: -1*labelWidth+'px',
      }"
    >{{ label }}</span>
    <!--    <span ref="child" class="value" value="" :class="{'on':innerValue===''}" @click="innerValue=''">全部</span>-->
    <span
      v-for="(item,index) in list "
      ref="child"
      :key="index"
      class="value"
      :value="item.value"
      :class="{'on':innerValue===item.value}"
      @click="changeVal(item.value)"
    >
      {{ item.name }}
      <span v-if="sort" class="sort">
        <i class="top" :class="{on:sortVal}" />
        <i class="bottom" :class="{on:!sortVal}" />
      </span>
    </span>
    <span v-if="childrenWidth>parentWidth" class="more" :class="{'on':show}" @click="show=!show">{{ show?'点击收起':'展开更多' }}</span>
  </div>
</template>

<script>
export default {
  name: 'UmSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    sort: { // 是否启用排序功能
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: Number,
      default: 50
    },
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: ''
    },
    sortType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      innerValue: '',
      parentWidth: 0,
      childrenWidth: 0,
      maxIndex: 0,
      show: false,
      resizeObserver: null
    }
  },
  computed: {
    sortVal: { // asc 正序 desc 倒序
      get(val) {
        return this.sortType === 'asc'
      },
      set(val) {
        this.$emit('update:sortType', val ? 'asc' : 'desc')
      }
    }
  },
  watch: {
    list: {
      handler(val) {
        this.$nextTick(() => {
          let sum = 0
          const index = 0
          this.parentWidth = this.$el.parentNode.clientWidth
          if (Array.isArray(this.$refs.child)) {
            this.$refs.child.forEach((item, idx) => {
              sum += item.clientWidth
            })
          }
          this.childrenWidth = sum + 110
          this.maxIndex = index
        })
      },
      immediate: true
    },
    innerValue(newVal, oldVal) {
      if (newVal !== this.value) { this.$emit('change', newVal) }
    },
    value: {
      handler(val) {
        this.innerValue = val
      },
      immediate: true
    }
  },
  created() {
  },
  mounted() {
    this.resize()
  },
  beforeDestroy() {
    this.resizeObserver.unobserve(this.$el)
  },
  methods: {
    changeVal(value) {
      if (this.innerValue === value) {
        this.sortVal = !this.sortVal
      } else {
        this.sortVal = true
      }
      this.innerValue = value
    },
    resize() {
      this.resizeObserver = new ResizeObserver((entries) => {
        // this.parentWidth = this.$el.clientWidth
        this.parentWidth = this.$el.parentNode.clientWidth
      })

      this.resizeObserver.observe(this.$el)
    }
  }
}
</script>

<style scoped lang="scss">
.um-control{
  position: relative;
  display: inline-block;
  vertical-align: top;
  //width: 100%;
  // padding-left: 50px;
  user-select: none;
  height: 28px;
  line-height: 28px;
  font-size: 0;
  padding-right: 60px;
  overflow: hidden;
  &.show{
    height: auto;
    padding-right: 0;
    .more{
      position: relative;
      top:5px;
      margin-top: 0;
    }
  }
  .label,.value{
    display: inline-block;
    vertical-align: middle;
  }
  .label{
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    text-align: right;
    padding-right: 10px;
  }
  .sort{
    position: relative;
    display: inline-block;
    width: 14px;
    height: 12px;
    top: 2px;
    .top{
      position: absolute;
      left:50%;
      top:0;
      transform: translateX(-50%);
      border-bottom: 5px solid #cfcfcf;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
    }
    .bottom{
      position: absolute;
      left:50%;
      bottom:0;
      transform: translateX(-50%);
      border-top: 5px solid #cfcfcf;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
    }
  }
  .value{
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    max-width: 8em;
    text-overflow: ellipsis;
    height: 28px;
    font-size: 14px;
    color: #666666;
    padding:0 8px;
    cursor: pointer;
    border-radius:4px;
    margin-right: 10px;
    &.on{
      background:#2B6FEF;
      color:#fff;
      .sort{
        .top{
          &.on{
            border-bottom-color: #fff;
          }
        }
        .bottom{
          &.on{
            border-top-color: #fff;
          }
        }
      }
    }
  }
  .more{
    position: absolute;
    right:0;
    top:50%;
    margin-top: -7px;
    height: 14px;
    font-size: 14px;
    color: #666666;
    line-height: 14px;
    padding:0 8px;
    cursor: pointer;
    &:after{
      position: absolute;
      right:0;
      top:50%;
      margin-top: -2px;
      content:"";
      display: block;
      width: 0;
      height: 0;
      border-bottom:4px solid #2B6FEF;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      transform: rotate(180deg);
      transition: all 300ms;
    }
    &.on{
      &:after{
        transform: rotate(0);
      }
    }
  }
}
</style>
